







import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface SocleBudget {
    hierarchyOwner: {
        clientCode1: string;
    };
}

@Component({ components: { SimpleText } })
export default class AnabelCode extends Vue {
    @Prop( { default: null }) public budget!: SocleBudget;

    public static getNeededFields(): string[] {
        return [
            "budget.hierarchyOwner.clientCode1"
        ];
    }
}
